import {
  BotoneraTemplateId,
  LoginTemplateId,
} from '../../../../auxiliares/plantillas/plantillas-spec';

/** Un botón tal como lo necesita el preview (subset de IBoton). */
export interface PreviewBoton {
  nombre?: string;
  /** Texto que se muestra EN el botón (pill de color). Si falta, cae a `nombre`. */
  texto?: string;
  funcion?: string;
  color?: string;
  urlImagen?: string;
}

/** Ítem del menú inferior (barra de navegación del shell). */
export interface NavSeccion {
  ic: string;
  l: string;
}

/** Modelo derivado del form que alimenta el preview en vivo. */
export interface PreviewVM {
  loginTemplate: LoginTemplateId;
  botoneraId: BotoneraTemplateId;
  brand: string;
  brandInk: string;
  sirenas: boolean;
  /** URLs de imagen (si están cargadas); el preview muestra placeholder si faltan. */
  fondo?: string;
  arriba?: string;
  abajo?: string;
  /** Imágenes de la fila de acciones (reflector/sirena/Más/Atrás), si el cliente o la categoría las cargó. */
  reflector?: string;
  sirena?: string;
  adelante?: string;
  atras?: string;
  login?: string;
  /** Hay chatbot = primer botón del grupo "Otros" (lo usa el template banner). */
  chat: boolean;
  /** Hay botones secundarios → se muestra "Más" en la fila inferior. */
  haySecundarios: boolean;
  principales: PreviewBoton[];
  secundarios: PreviewBoton[];
  otros: PreviewBoton[];
  /** Secciones del menú inferior (sin Inicio ni Más), según los flags de módulos. */
  navSecciones: NavSeccion[];
}

/** Color de texto contrastante sobre un color de marca (igual criterio que helper.invertColor). */
export function brandInk(hex?: string): string {
  if (!hex || hex.length < 7) return '#1a1206';
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 150 ? '#1a1206' : '#ffffff';
}

/* eslint-disable @typescript-eslint/no-explicit-any */

/** Construye el PreviewVM a partir del valor del form del provisionador. */
export function construirPreviewVM(
  formValue: any,
  botones: any[],
  idsPrincipales: string[],
  idsOtros: string[],
  idsSecundarios: string[] = [],
): PreviewVM {
  const porTmp = (id: string): PreviewBoton | undefined => {
    const b = botones.find((x) => x._tmpId === id);
    if (!b) return undefined;
    return {
      nombre: b.nombre,
      texto: b.texto,
      funcion: b.funcion,
      color: b.color,
      urlImagen: b.urlImagen,
    };
  };
  const mapGrupo = (ids: string[]): PreviewBoton[] =>
    ids.map(porTmp).filter((b): b is PreviewBoton => !!b);
  const principales = mapGrupo(idsPrincipales);
  const secundarios = mapGrupo(idsSecundarios);
  const otros = mapGrupo(idsOtros);

  const cfg = formValue?.configuracion || {};
  const brand = cfg.colorTema || '#FB972E';
  const img = formValue?.imagenes || {};

  // Secciones del menú inferior gateadas por flags (igual que ClienteRuntime). Alertas y
  // Notificaciones van siempre; el resto según el módulo.
  const navSecciones: NavSeccion[] = [
    { ic: '⚠', l: 'Alertas' },
    { ic: '🔔', l: 'Notif.' },
  ];
  if (cfg.mostrarMapa) navSecciones.push({ ic: '🗺', l: 'Cobertura' });
  if (cfg.verContactos) navSecciones.push({ ic: '👥', l: 'Contactos' });
  if (cfg.verEventos) navSecciones.push({ ic: '📅', l: 'Eventos' });
  if (cfg.verReclamos) navSecciones.push({ ic: '📣', l: 'Reclamos' });
  if (cfg.verColectivos) navSecciones.push({ ic: '🚌', l: 'Colectivos' });

  return {
    loginTemplate: (formValue?.loginTemplate as LoginTemplateId) || 'default',
    botoneraId: (formValue?.inicioTemplate as BotoneraTemplateId) || 'grid',
    brand,
    brandInk: brandInk(brand),
    sirenas: !!formValue?.sirenas,
    fondo: img.fondo || undefined,
    arriba: img.arriba || undefined,
    abajo: img.abajo || undefined,
    reflector: img.reflector || undefined,
    sirena: img.sirena || undefined,
    adelante: img.adelante || undefined,
    atras: img.atras || undefined,
    login: img.login || undefined,
    chat: idsOtros.length > 0,
    haySecundarios: idsSecundarios.length > 0,
    principales,
    secundarios,
    otros,
    navSecciones,
  };
}
